import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BrandStory from './components/BrandStory';
import Reviews from './components/Reviews';
import ContactSection from './components/ContactSection';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于愽彩糖果',
  description: '愽彩糖果创立于2018年，专注于缤纷糖果在线销售与批发，拥有200+精选糖果产品，涵盖六大品类。',
  url: 'https://bocaicandy.com/about',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '愽彩糖果',
  url: 'https://bocaicandy.com',
  description: '愽彩糖果网站汇聚海量缤纷糖果，提供多口味、多品类糖果在线选购服务。',
  email: 'service@bocaicandy.com',
  telephone: '400-888-6666',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CN',
    addressLocality: '广州市',
    addressRegion: '广东省',
    streetAddress: '天河区珠江新城华夏路88号',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '09:00',
      closes: '21:00',
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '愽彩糖果支持哪些支付方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们支持微信支付、支付宝、银联卡等多种支付方式，确保您的购物体验便捷安全。',
      },
    },
    {
      '@type': 'Question',
      name: '糖果配送需要多长时间？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '全国多仓发货，一般情况下下单后24小时内发货，1-3个工作日送达。偏远地区可能稍有延迟。',
      },
    },
    {
      '@type': 'Question',
      name: '散装糖果批发起订量是多少？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '散装糖果5斤起批，量大更优惠。我们提供灵活的混批搭配服务，欢迎联系客服获取详细报价。',
      },
    },
    {
      '@type': 'Question',
      name: '糖果礼盒可以定制吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '可以的！我们提供糖果礼盒定制服务，包括内容搭配、包装设计和贺卡定制等，详情请联系客服。',
      },
    },
    {
      '@type': 'Question',
      name: '糖果的保质期是多久？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '不同品类的糖果保质期有所不同，一般在6-12个月之间。每款产品包装上均明确标注生产日期和保质期，请放心购买。',
      },
    },
  ],
};

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>
        <BrandStory />
        <Reviews />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}